import { Calendar } from 'react-widgets';
import React, { FC } from 'react';
interface Props {
    open?: false | 'date' | 'time';
    navigateDate: (val: Date) => void;
    setDate: (val: Date) => void;
    min?: any;
    max?: any;
    view?: any;
    nowDate?: any;
    containerClassName?: any;
}

const SimpleCalendar: FC<Props> = ({ navigateDate, containerClassName, setDate, min, max, view, nowDate }: Props) => {
    const onNavig = (date: Date) => {
        navigateDate(date);
    };

    const handleChange = (date?: Date) => {
        setDate(date ? date : new Date());
    };

    return (
        <div className={containerClassName}>
            <Calendar
                min={min}
                max={max}
                currentDate={nowDate}
                onChange={handleChange}
                onNavigate={onNavig}
                footer={false}
                defaultView={view ? view : undefined}
                view={view}
            />
        </div>
    );
};
export default SimpleCalendar;
